/* ==========================================================================
   uq-reveal.js
   Scroll reveal for Shopify theme sections — Uniq Creative
   Pairs with uq-reveal.css. No dependencies.
   ========================================================================== */

(function () {
  'use strict';

  if (window.UQReveal) return;

  var DEFAULT_STAGGER = 70; // ms between children
  var MAX_STEPS = 6; // cap the stagger so long grids don't crawl

  var reducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function show(el, instant) {
    if (instant) el.style.setProperty('--uq-reveal-delay', '0ms');
    el.classList.add('uq-reveal--visible');
  }

  function inViewport(el) {
    var rect = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return rect.top < vh && rect.bottom > 0;
  }

  function setupGroup(group) {
    if (group.hasAttribute('data-uq-reveal-init')) return;
    group.setAttribute('data-uq-reveal-init', '');

    // Sections often emit {% style %} output as a direct child. Those elements
    // never render, so they must not consume a stagger slot.
    var items = Array.prototype.filter.call(group.children, function (el) {
      return !/^(STYLE|SCRIPT|TEMPLATE|LINK|NOSCRIPT)$/.test(el.tagName);
    });
    if (!items.length) return;

    var stagger = parseInt(group.getAttribute('data-uq-reveal-stagger'), 10);
    if (isNaN(stagger)) stagger = DEFAULT_STAGGER;

    var animateOnLoad = group.getAttribute('data-uq-reveal-on-load') === 'true';

    items.forEach(function (el, i) {
      el.style.setProperty('--uq-reveal-delay', Math.min(i, MAX_STEPS) * stagger + 'ms');
    });

    // No observer support, or the visitor prefers reduced motion: show it all.
    if (reducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (el) {
        show(el, true);
      });
      return;
    }

    // Anything already on screen at first paint is shown without animating,
    // so above-the-fold content (and LCP) is never delayed. Opt in per section
    // with data-uq-reveal-on-load="true".
    if (!animateOnLoad) {
      items.forEach(function (el) {
        if (inViewport(el)) show(el, true);
      });
    }

    var observer = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          show(entry.target);
          obs.unobserve(entry.target);
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -8% 0px' }
    );

    items.forEach(function (el) {
      if (!el.classList.contains('uq-reveal--visible')) observer.observe(el);
    });

    group.uqRevealObserver = observer;
  }

  function init(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var groups = scope.querySelectorAll('[data-uq-reveal]:not([data-uq-reveal-init])');
    Array.prototype.forEach.call(groups, setupGroup);

    // Covers the case where the section root itself is the reveal container.
    if (root && root.matches && root.matches('[data-uq-reveal]')) setupGroup(root);
  }

  window.UQReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  /* --- Theme editor ------------------------------------------------------ */
  // Sections are re-rendered on save, so re-bind. Without this, edited
  // sections stay invisible in the customiser and look broken to the client.

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });

  // When a block is selected, make sure it is visible even if off screen.
  document.addEventListener('shopify:block:select', function (e) {
    var group = e.target.closest('[data-uq-reveal]');
    if (!group) return;
    var child = e.target;
    while (child && child.parentElement !== group) child = child.parentElement;
    if (child) show(child, true);
  });
})();
